// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgIdTrue: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
      role="presentation"
      {...props}
    >
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path d="M16.969 11.028a.493.493 0 0 1-.5.486h-3a.493.493 0 0 1-.5-.486c0-.268.224-.486.5-.486h3c.276 0 .5.218.5.486" />
        <path d="M16.469 13.458c.276 0 .5-.218.5-.486a.493.493 0 0 0-.5-.486h-3c-.276 0-.5.217-.5.486 0 .268.224.486.5.486z" />
        <path d="M9.248 11.783a1.287 1.287 0 0 1-.64-.333 1.219 1.219 0 0 1 .325-1.992 1.15 1.15 0 0 1 .568-.13c.226 0 .364.032.569.13.325.155.567.441.668.79.046.156.047.474.002.63a1.286 1.286 0 0 1-.906.887c-.149.04-.44.048-.586.018" />
        <path d="M12 13.97a.263.263 0 0 1-.023.106l-.07.167a.72.72 0 0 1-.666.433H7.76a.72.72 0 0 1-.666-.433l-.05-.12a.535.535 0 0 1-.041-.208c.02-.341.22-.686.554-.973.471-.404 1.207-.695 1.944-.695.736 0 1.473.29 1.944.695.351.301.556.669.556 1.028" />
        <path
          fillRule="evenodd"
          d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12M8 7.385c-1.105 0-2 .87-2 1.943v5.344c0 1.073.895 1.943 2 1.943h8c1.105 0 2-.87 2-1.943V9.328c0-1.073-.895-1.943-2-1.943z"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

const Memo = memo(SvgIdTrue);
export default Memo;
